
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-resources/-embroider-implicit-modules.js";
